module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-04-dfce3182355f4fad263d0eaba0986a15.jpg";